import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  AllCollegeType,
  AllGender,
} from "../../../../features/admin/common/Slice";
import { Controller } from "react-hook-form";

function CollageRegistration_step_2({ register, errors, control, getValues }) {
  const dispatch = useDispatch();

  console.log(getValues("college_type_id.value"), "getValues");

  const college_type = useSelector((state) => state.common.all_college_type);

  useEffect(() => {
    dispatch(AllCollegeType());
  }, [dispatch]);

  return (
    <>
      <h5 className="step-heading">B. School Identity</h5>

      <div className="form_holder">
        <div className="row">
          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>College Type </Form.Label>
              <Controller
                name="college_type_id"
                control={control}
                rules={{ required: "College Type is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={college_type}
                    onInputChange={(val) => {
                      dispatch(AllCollegeType(val));
                    }}
                    className="react-select-container"
                    classNamePrefix="react-select"
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                  />
                )}
              />
              {errors?.college_type_id && (
                <Form.Text className="text-danger">
                  {errors?.college_type_id?.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          {getValues("college_type_id.value") == 3 && (
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Other College Type</Form.Label>
                <Form.Control
                  type="text"
                  {...register("college_type", {
                    required: "College Type is required",
                  })}
                  placeholder="Enter College Type"
                />{" "}
                {errors.college_type && (
                  <Form.Text className="text-danger">
                    {errors.college_type.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
          )}

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Accreditation Authority Name</Form.Label>
              <Form.Control
                {...register("acc_auth_name", {
                  required: "Accreditation Authority Name is required",
                })}
                placeholder="Enter Accreditation Authority Name"
              />{" "}
              {errors.acc_auth_name && (
                <Form.Text className="text-danger">
                  {errors.acc_auth_name.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Accreditation Validity Name</Form.Label>
              <Form.Control
                {...register("acc_val_period", {
                  required: "Accreditation Validity Name is required",
                })}
                placeholder="Enter Accreditation Validity Name"
              />{" "}
              {errors.acc_val_period && (
                <Form.Text className="text-danger">
                  {errors.acc_val_period.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Registration Number</Form.Label>
              <Form.Control
                {...register("reg_no", {
                  required: "Registration Number is required",
                })}
                placeholder="Enter Registration Number"
              />{" "}
              {errors.reg_no && (
                <Form.Text className="text-danger">
                  {errors.reg_no.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Country</Form.Label>
              <Form.Control
                {...register("country", {
                  required: "Country is required",
                })}
                placeholder="Enter Country"
              />{" "}
              {errors.country && (
                <Form.Text className="text-danger">
                  {errors.country.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>State</Form.Label>
              <Form.Control
                {...register("state", {
                  required: "State is required",
                })}
                placeholder="Enter State"
              />{" "}
              {errors.state && (
                <Form.Text className="text-danger">
                  {errors.state.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>City</Form.Label>
              <Form.Control
                {...register("city", {
                  required: "City is required",
                })}
                placeholder="Enter City"
              />{" "}
              {errors.city && (
                <Form.Text className="text-danger">
                  {errors.city.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Postal Code</Form.Label>
              <Form.Control
                {...register("pincode", {
                  required: "Postal Code is required",
                })}
                placeholder="Enter Postal Code"
              />{" "}
              {errors.pincode && (
                <Form.Text className="text-danger">
                  {errors.pincode.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-12">
            <Form.Group className="mb-3">
              <Form.Label>Street</Form.Label>
              <Form.Control
                {...register("street", {
                  required: "Street is required",
                })}
                placeholder="Enter Street"
              />{" "}
              {errors.street && (
                <Form.Text className="text-danger">
                  {errors.street.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>
        </div>
      </div>
    </>
  );
}

export default CollageRegistration_step_2;
